import {fetchAndParse, FetchResult} from './Common';
import {ApiName} from '../api/Common';
interface DocumentApiOptions {
	apiName: ApiName;
}

export class DocumentApiClass {
	private static _instance: DocumentApiClass;
	static instance() {
		return (this._instance = this._instance || new DocumentApiClass());
	}
	private constructor() {}

	private _resultByUrl: Map<string, FetchResult> = new Map();
	url(options: DocumentApiOptions) {
		const path = options.apiName == ApiName.INDEX ? 'index' : options.apiName;
		return `/editor/docs/description/api/${path.toLowerCase()}.md`;
	}

	async fetch(options: DocumentApiOptions): Promise<FetchResult | undefined> {
		const url = this.url(options);
		let result = this._resultByUrl.get(url);
		if (!result) {
			result = await fetchAndParse(url);
		}
		return result;
	}
}

export const DocumentApi = DocumentApiClass.instance();
